module.exports = __webpack_public_path__ + "img/dinplus.3e0d628.png";